<template>
    <DCard
        :title="$t('common.edit')"
        padding
    >
        <Form
            :available-permissions="availablePermissions"
            :errors="errors"
            :role="role"
            @save-role="saveRole"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Roles/Form'
import { router } from '@inertiajs/vue3'

export default {
    name: 'RoleEdit',
    components: { Form },
    props: {
        availablePermissions: {
            type: Array,
            default: () => { return [] }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        role: {
            type: Object,
            default: () => { return {} }
        }
    },
    methods: {
        saveRole (data) {
            router.put(this.$route('roles.update', { role: this.role.id }), data)
        }
    }
}
</script>
